import React from 'react'

import { PercentageBadge, ProgressBar, SeverityChip, SummaryText } from './components'
import { getSeverityHelpText, getSeverityIcon, getSeverityLabel, getSeverityLevel, toPercent } from './constants'
import { SEVERITY_THEMES } from './themes'

import s from './styles.module.scss'

function AbsenteeismRiskIndicator({ absentPercentage }) {
  const { absentism = 0, absentTurns = 0, totalTurns = 0 } = absentPercentage || {}
  const percent = toPercent(absentism)
  const level = getSeverityLevel(percent, totalTurns)
  const label = getSeverityLabel(level)
  const Icon = getSeverityIcon(level)
  const theme = SEVERITY_THEMES[level]
  const hasTurnsHistory = totalTurns > 0
  const helpText = hasTurnsHistory ? getSeverityHelpText(level) : 'Sin historial suficiente'

  return (
    <div className={s.card}>
      <div className={s.left}>
        <PercentageBadge
          percent={percent}
          badgeClassName={`${s.badge} ${theme.badge}`}
          numClassName={s.badgeNum}
          pctClassName={s.badgePct}
        />
      </div>

      <div className={s.middle}>
        <div className={s.middleTop}>
          <SeverityChip
            label={label}
            icon={Icon}
            className={`${s.severityChip} ${theme.chip}`}
            iconClassName={s.severityIcon}
          />
          <SummaryText absentTurns={absentTurns} totalTurns={totalTurns} className={s.summary} />
        </div>
        <ProgressBar percent={percent} trackClassName={s.barTrack} fillClassName={`${s.barFill} ${theme.bar}`} />
      </div>

      <div className={s.right}>
        <div className={`${s.helpText} ${theme.helpText}`}>{helpText}</div>
        <Icon className={`${s.helpIcon} ${theme.helpText}`} fontSize="inherit" />
      </div>
    </div>
  )
}

export default AbsenteeismRiskIndicator
